import gql from 'graphql-tag';

export const ECHELON_INFO_FRAGMENT = gql`
  fragment EchelonInfo on Echelon {
    id
    name
    priority
  }
`;
